/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  /* ===========================================================
     Subscription widget — conversion redesign
     Works with the Shopify Subscriptions app block (.plan_card).
     Pairs with the .cro-* styles in custom.css.
     ----------------------------------------------------------
     EDIT COPY HERE — keep claims truthful for this store.
     (Confirm "Free delivery" / "Price lock" actually apply, or
      swap them for something you do offer, e.g. "Pause anytime".)
     =========================================================== */
  var CONFIG = {
    subscribeTitle: 'Subscribe & save',
    oneTimeTitle:   'One-time purchase',
    popularBadge:   'Most popular',
    subscribeMeta:  '{plan}',         // {plan} = delivery frequency auto-read from the app's widget
                                      // (the selling plan name, e.g. "Deliver every month").
                                      // Use plain text to hard-code it instead.
    subscribeMetaFallback: 'Deliver every month', // shown if the plan name can't be detected
    savingsLabel:   '{percent}% off', // {percent} = discount auto-read from the app's widget.
                                      // Use plain text (e.g. '15% off') to hard-code, or '' to hide the pill.
    savingsFallback: '',              // shown if no discount can be detected ('' hides the pill)
    oneTimeSub:     'No commitment · ships once',
    selectSubscribeByDefault: true,
    liftPrice: true,                 // move the plan price up onto the title row
    trust: [
      { icon: 'refresh', text: 'Skip or cancel anytime' },
      { icon: 'truck',   text: 'Free delivery' },
      { icon: 'lock',    text: 'Price lock' }
    ]
  };

  var ICONS = {
    refresh: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>',
    truck:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="13" height="11" rx="1.5"/><path d="M14 8h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.7"/><circle cx="17.5" cy="18" r="1.7"/></svg>',
    lock:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>'
  };

  var MONEY = /[\$£€]\s?\d|\d[.,]\d{2}/;
  var PERCENT = /(\d+(?:[.,]\d+)?)\s*%/;

  /* ---- Dynamic savings detection ----------------------------------------
     The app's own widget already carries the discount: usually as a
     "...15%..." somewhere in the subscribe option's text, and always in the
     difference between the subscribe and one-time prices. We read it from
     there so the pill stays correct when the selling-plan discount changes.
     The result is cached on .plan_card because our relabelling removes some
     of the app's original text. */
  function moneyValue(el) {
    if (!el) return NaN;
    var m = (el.textContent || '').match(/\d[\d.,\s]*\d|\d/);
    if (!m) return NaN;
    var s = m[0].replace(/\s/g, '');
    var dot = s.lastIndexOf('.'), comma = s.lastIndexOf(',');
    if (dot > -1 && comma > -1) {            // both present: the later one is the decimal mark
      var dec = Math.max(dot, comma);
      s = s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1);
    } else if (comma > -1) {                 // comma only: decimal if 2 digits follow, else thousands
      s = (s.length - comma - 1 === 2) ? s.replace(',', '.') : s.replace(/,/g, '');
    }
    return parseFloat(s);
  }

  function detectPercent(sub) {
    var pc = document.querySelector('.plan_card');
    if (pc && pc.getAttribute('data-cro-percent')) return pc.getAttribute('data-cro-percent');

    var pct = '';
    // 1) The app prints the % somewhere in the subscribe option (plan name,
    //    discount summary...). Search a clone with our injected nodes removed
    //    so we never re-read our own pill.
    if (sub) {
      var clone = sub.cloneNode(true);
      Array.prototype.forEach.call(
        clone.querySelectorAll('.cro-meta, .cro-trust, .cro-badge, .cro-onetime-sub'),
        function(n) { n.parentNode.removeChild(n); }
      );
      var m = PERCENT.exec(clone.textContent || '');
      if (m) pct = String(parseFloat(m[1].replace(',', '.')));
    }
    // 2) Fallback: derive it from subscribe price vs one-time price.
    if (!pct) {
      var subPrice = moneyValue(findPriceEl(sub, null));
      var otpPrice = moneyValue(findPriceEl(oneTimeGroup(), null));
      if (subPrice > 0 && otpPrice > 0 && subPrice < otpPrice) {
        var p = Math.round((1 - subPrice / otpPrice) * 100);
        if (p >= 1 && p <= 90) pct = String(p);
      }
    }

    if (pct && pc) pc.setAttribute('data-cro-percent', pct);
    return pct;
  }

  /* Resolve the pill text: fill {percent} from the widget, or fall back. */
  function savingsText(sub) {
    var tpl = CONFIG.savingsLabel;
    if (!tpl || tpl.indexOf('{percent}') === -1) return tpl || '';
    var pct = detectPercent(sub);
    return pct ? tpl.replace('{percent}', pct) : CONFIG.savingsFallback;
  }

  /* ---- Dynamic delivery-frequency detection ------------------------------
     The app renders the selling plan name (e.g. "Deliver every month") in
     the plan row we later hide. Read it from there: first text leaf in the
     subscribe option that isn't the title, a price, or a bare discount. */
  function detectPlanText(sub) {
    var pc = document.querySelector('.plan_card');
    if (pc && pc.getAttribute('data-cro-plan')) return pc.getAttribute('data-cro-plan');
    if (!sub) return '';

    var clone = sub.cloneNode(true);
    Array.prototype.forEach.call(
      clone.querySelectorAll('.cro-meta, .cro-trust, .cro-badge, .group_name'),
      function(n) { n.parentNode.removeChild(n); }
    );
    var found = '';
    var els = clone.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector('*')) continue;                 // leaf only
      var t = (el.textContent || '').trim();
      if (!t || MONEY.test(t)) continue;                   // skip prices
      var hadPercent = PERCENT.test(t);
      // strip an embedded discount fragment, e.g. ", 15% off" or "(save 15%)"
      var cleaned = t
        .replace(/[,(]?\s*(?:save\s*)?\d+(?:[.,]\d+)?\s*%[^,)]*\)?/gi, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/^[\s,·|-]+|[\s,·|-]+$/g, '');
      if (cleaned.length < 3 || cleaned.length > 60) continue;
      if (/^[A-Z]{2,4}$/.test(cleaned)) continue;          // currency code leftovers
      if (hadPercent && cleaned.split(/\s+/).length < 2) continue; // was just "Save 15%" etc.
      found = cleaned;
      break;
    }

    if (found && pc) pc.setAttribute('data-cro-plan', found);
    return found;
  }

  /* Resolve the meta line: fill {plan} from the widget, or fall back. */
  function metaText(sub) {
    var tpl = CONFIG.subscribeMeta;
    if (!tpl || tpl.indexOf('{plan}') === -1) return tpl || '';
    var plan = detectPlanText(sub);
    return plan ? tpl.replace('{plan}', plan) : CONFIG.subscribeMetaFallback;
  }

  /* ---- locate the two option groups ---- */
  function subscribeGroup() {
    var i = document.querySelector('.plan_card input[data-radio-type="selling_plan"]');
    return i ? i.closest('.subscription_group') : null;
  }
  function oneTimeGroup() {
    var i = document.querySelector('.plan_card input[data-radio-type="one_time_purchase"]');
    return i ? i.closest('.subscription_group') : null;
  }
  function headerOf(group) {
    if (!group) return null;
    var name = group.querySelector('.group_name');
    if (name) return name.closest('label') || name.parentElement;
    // One-time option has no .group_name — fall back to its radio's row.
    var input = group.querySelector('input[type="radio"]');
    if (input) return input.closest('label') || input.parentElement;
    return null;
  }

  /* Only apply our customisations when the widget is in CARD style with the
     RADIO selector. Card style => .plan_card exists; radio selector =>
     .custom_radio_button exists (Dropdown renders a <select> instead).
     In any other combination we leave the app's widget completely untouched. */
  function isCardRadio() {
    var pc = document.querySelector('.plan_card');
    return !!(pc && pc.querySelector('.custom_radio_button'));
  }

  /* Insert `node` directly after the header row, safely inside the group. */
  function insertAfterHeader(group, header, node) {
    if (header && header.parentNode === group && header.nextSibling) {
      group.insertBefore(node, header.nextSibling);
    } else {
      group.appendChild(node);
    }
  }

  /* ---- 1. Subscribe option first ---- */
  function reorderSubscriptionOptions() {
    var planCard = document.querySelector('.plan_card');
    var sub = subscribeGroup(), otp = oneTimeGroup();
    if (planCard && sub && otp && sub.previousElementSibling !== null) {
      planCard.insertBefore(sub, otp);
    }
  }

  /* ---- 2. Pre-select Subscribe ---- */
  function selectSubscribeByDefault() {
    if (!CONFIG.selectSubscribeByDefault) return;
    var subRadio = document.querySelector('.plan_card input[data-radio-type="selling_plan"]');
    if (!subRadio || subRadio.checked) return;
    var otpRadio = document.querySelector('.plan_card input[data-radio-type="one_time_purchase"]');
    if (otpRadio) otpRadio.checked = false;
    subRadio.checked = true;
    subRadio.dispatchEvent(new Event('change', { bubbles: true }));
    var hidden = document.querySelector('input.selected-selling-plan-id');
    if (hidden) hidden.value = subRadio.getAttribute('data-selling-plan-id') || '';
  }

  /* ---- 3. Relabel a title while preserving an injected badge ---- */
  function setTitle(group, text) {
    var name = group && group.querySelector('.group_name');
    if (!name) return;
    var firstText = '';                                    // current leading text node
    for (var i = 0; i < name.childNodes.length; i++) {
      if (name.childNodes[i].nodeType === 3) { firstText = name.childNodes[i].nodeValue.trim(); break; }
    }
    if (firstText === text) return;                        // already set -> no mutation (avoids observer loop)
    Array.prototype.slice.call(name.childNodes).forEach(function(n) {
      if (n.nodeType === 3) name.removeChild(n);           // drop app text nodes
    });
    name.insertBefore(document.createTextNode(text), name.firstChild);
  }

  /* ---- 4. "Most popular" badge on the Subscribe title ---- */
  function injectBadge(group) {
    if (!group || group.querySelector('.cro-badge')) return;
    var name = group.querySelector('.group_name');
    if (!name) return;
    var badge = document.createElement('span');
    badge.className = 'cro-badge';
    badge.textContent = CONFIG.popularBadge;
    name.appendChild(badge);
  }

  /* ---- 5. Find the plan price element (leaf, with a small climb) ---- */
  function findPriceEl(scope, exclude) {
    var els = scope.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (exclude && exclude.contains(el)) continue;
      if (el.querySelector('*')) continue;                 // leaf only
      var t = (el.textContent || '').trim();
      if (!t || !MONEY.test(t) || t.length > 14) continue;
      var node = el, p = node.parentElement;               // climb to grab "$84.15 USD"
      if (p && p !== scope && !(exclude && exclude.contains(p)) &&
          !p.querySelector('input') && !p.querySelector('.group_name')) {
        var pt = p.textContent.trim();
        if (MONEY.test(pt) && pt.length <= 18) node = p;
      }
      return node;
    }
    return null;
  }

  /* ---- 6. Move the radio + price onto the title row; hide the leftover
            text row. Crucially the SELECTION RADIO stays visible and
            clickable (it just moves up), so switching options keeps working. */
  function restructureSubscribe(group, header) {
    if (!CONFIG.liftPrice) return;
    if (!group || !header || header.querySelector('.cro-price')) return; // already done
    var name = group.querySelector('.group_name');
    var radio = group.querySelector('input[data-radio-type="selling_plan"]');
    var priceEl = findPriceEl(group, header);
    if (!priceEl) return;                                   // not confident -> leave app layout intact

    // Work out the original sub-row (radio + plan text + price) to hide later.
    var row = priceEl;
    while (row.parentElement && row.parentElement !== group) {
      if (row.parentElement === header || (name && row.parentElement.contains(name))) break;
      row = row.parentElement;
    }
    var canHideRow = row && row !== header && !(name && row.contains(name));

    // 1) Move the selection radio onto the title row (keeps it clickable).
    if (radio && radio.parentElement !== header) {
      header.insertBefore(radio, header.firstChild);
    }
    // 2) Move the price onto the title row (same node, so app price updates still apply).
    priceEl.classList.add('cro-price');
    header.appendChild(priceEl);
    // 3) Hide the now-empty plan text row (our injected meta replaces it).
    if (canHideRow && !row.contains(priceEl) && !row.contains(radio)) {
      row.classList.add('cro-hidden-row');
    }
  }

  /* Make the whole card selectable (and re-selectable) like the reference. */
  function enableCardClicks() {
    if (document.documentElement.hasAttribute('data-cro-clicks')) return;
    document.documentElement.setAttribute('data-cro-clicks', '1');
    document.addEventListener('click', function(e) {
      if (!isCardRadio()) return;
      var group = e.target.closest && e.target.closest('.plan_card .subscription_group');
      if (!group) return;
      if (e.target.closest('input, a, button, select, label')) return; // let native handle
      var radio = group.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ---- 7. Meta row: "Deliver every month" + green savings pill ---- */
  function injectMeta(group, header, metaTxt, pillText) {
    if (!group || group.querySelector('.cro-meta')) return;
    if (!metaTxt && !pillText) return;
    var meta = document.createElement('div');
    meta.className = 'cro-meta';
    meta.innerHTML =
      (metaTxt ? '<span class="cro-sub">' + metaTxt + '</span>' : '') +
      (pillText ? '<span class="cro-pill">' + pillText + '</span>' : '');
    insertAfterHeader(group, header, meta);
  }

  /* ---- 8. Trust row under the Subscribe card ---- */
  function injectTrust(group) {
    if (!group || group.querySelector('.cro-trust')) return;
    var row = document.createElement('div');
    row.className = 'cro-trust';
    row.innerHTML = CONFIG.trust.map(function(it) {
      return '<span>' + (ICONS[it.icon] || '') + it.text + '</span>';
    }).join('');
    group.appendChild(row);
  }

  /* ---- 9. One-time subtitle ---- */
  function injectOneTimeSub(group, header) {
    if (!group || !CONFIG.oneTimeSub || group.querySelector('.cro-onetime-sub')) return;
    var sub = document.createElement('div');
    sub.className = 'cro-onetime-sub';
    sub.textContent = CONFIG.oneTimeSub;
    insertAfterHeader(group, header, sub);
  }

  /* ---- 10. Selected-state class for the cream highlight ---- */
  function syncSelected() {
    document.querySelectorAll('.plan_card .subscription_group').forEach(function(group) {
      var radio = group.querySelector('input[type="radio"]');
      group.classList.toggle('is-selected', !!(radio && radio.checked));
    });
  }

  function hidePolicy() {
    var p = document.querySelector('.shopify_subscriptions_app_policy');
    if (p) p.style.display = 'none';
  }

  /* Reveal the widget (custom.css keeps it invisible until this runs,
     so shoppers never see the raw app layout before the restyle). */
  function reveal() {
    var pc = document.querySelector('.plan_card');
    if (pc) pc.classList.add('cro-ready');
  }

  function runAll() {
    if (!isCardRadio()) return;                            // card + radio only
    enableCardClicks();
    reorderSubscriptionOptions();
    selectSubscribeByDefault();

    var sub = subscribeGroup();
    var subHead = headerOf(sub);
    if (sub && subHead) {
      // Read the % and plan name BEFORE relabelling strips app text.
      var pill = savingsText(sub);
      var meta = metaText(sub);
      subHead.classList.add('cro-head');
      setTitle(sub, CONFIG.subscribeTitle);
      injectBadge(sub);
      restructureSubscribe(sub, subHead);
      injectMeta(sub, subHead, meta, pill);
      injectTrust(sub);
    }

    var otp = oneTimeGroup();
    var otpHead = headerOf(otp);
    if (otp) {
      setTitle(otp, CONFIG.oneTimeTitle);                  // no-op if it has no .group_name
      if (otpHead && otpHead !== otp) otpHead.classList.add('cro-otp-head'); // bold/dark title; avoid hitting the subtitle
      var otpPrice = findPriceEl(otp, null);               // style its price like the Subscribe price
      if (otpPrice) otpPrice.classList.add('cro-price');
      injectOneTimeSub(otp, otpHead);
    }

    hidePolicy();
    syncSelected();
    reveal();
  }

  /* Keep the highlight in sync when the shopper switches option */
  document.addEventListener('change', function(e) {
    if (!isCardRadio()) return;
    if (e.target && e.target.closest && e.target.closest('.plan_card')) {
      syncSelected();
    }
  });

  if (document.readyState !== 'loading') runAll();
  document.addEventListener('DOMContentLoaded', runAll);
  setTimeout(runAll, 500);
  setTimeout(runAll, 1500);

  // Safety net: re-apply if the widget re-renders (e.g. on variant change).
  var debounce;
  var observer = new MutationObserver(function() {
    clearTimeout(debounce);
    debounce = setTimeout(function() {
      if (document.querySelector('.plan_card')) runAll();
    }, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();




// /*
// * Broadcast Theme
// *
// * Use this file to add custom Javascript to Broadcast.  Keeping your custom
// * Javascript in this fill will make it easier to update Broadcast. In order
// * to use this file you will need to open layout/theme.liquid and uncomment
// * the custom.js script import line near the bottom of the file.
// */

// (function() {
//   function selectSubscribeByDefault() {
//     const subRadio = document.querySelector('input[data-radio-type="selling_plan"]');
//     if (!subRadio || subRadio.checked) return;
//     const otpRadio = document.querySelector('input[data-radio-type="one_time_purchase"]');
//     if (otpRadio) otpRadio.checked = false;
//     subRadio.checked = true;
//     subRadio.dispatchEvent(new Event('change', { bubbles: true }));
//     const hiddenInput = document.querySelector('input.selected-selling-plan-id');
//     if (hiddenInput) {
//       hiddenInput.value = subRadio.getAttribute('data-selling-plan-id') || '';
//     }
//   }

//   function appendSubscriptionText() {
//     const allLabels = document.querySelectorAll('label, span.group_name');
//     allLabels.forEach(label => {
//       if (label.textContent.trim() === 'Subscribe and Save' && 
//           !label.textContent.includes('Auto-renews')) {
//         label.textContent += ' ( Auto-renews, skip or cancel anytime )';
//       }
//     });
//   }

//   function hideOriginalPolicyText() {
//     const policyElement = document.querySelector('.shopify_subscriptions_app_policy');
//     if (policyElement) {
//       policyElement.style.display = 'none';
//     }
//   }

//   function reorderSubscriptionOptions() {
//     const planCard = document.querySelector('.plan_card');
//     if (!planCard) return false;

//     const groups = planCard.querySelectorAll('.subscription_group');
//     if (groups.length < 2) return false;

//     let otpGroup = null;
//     let subGroup = null;

//     groups.forEach(group => {
//       if (group.querySelector('input[data-radio-type="one_time_purchase"]')) {
//         otpGroup = group;
//       } else if (group.querySelector('input[data-radio-type="selling_plan"]')) {
//         subGroup = group;
//       }
//     });

//     if (subGroup && otpGroup && subGroup.previousElementSibling !== null) {
//       planCard.insertBefore(subGroup, otpGroup);
//       return true;
//     }
//     return false;
//   }

//   function runAll() {
//     reorderSubscriptionOptions();
//     selectSubscribeByDefault();
//     appendSubscriptionText();
//     hideOriginalPolicyText();
//   }

//   // Initial attempts
//   setTimeout(runAll, 500);
//   setTimeout(runAll, 1500);

//   // MutationObserver as a safety net in case widget loads late or re-renders
//   const observer = new MutationObserver(() => {
//     const planCard = document.querySelector('.plan_card');
//     if (planCard) {
//       runAll();
//     }
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   // Stop observing after 10 seconds to avoid unnecessary work
//   setTimeout(() => observer.disconnect(), 10000);
// })();




/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// (function() {
//   function selectSubscribeByDefault() {
//     const subRadio = document.querySelector('input[data-radio-type="selling_plan"]');
//     if (!subRadio || subRadio.checked) return;
//     const otpRadio = document.querySelector('input[data-radio-type="one_time_purchase"]');
//     if (otpRadio) otpRadio.checked = false;
//     subRadio.checked = true;
//     subRadio.dispatchEvent(new Event('change', { bubbles: true }));
//     const hiddenInput = document.querySelector('input.selected-selling-plan-id');
//     if (hiddenInput) {
//       hiddenInput.value = subRadio.getAttribute('data-selling-plan-id') || '';
//     }
//   }

//   function appendSubscriptionText() {
//     const allLabels = document.querySelectorAll('label, span.group_name');
//     allLabels.forEach(label => {
//       if (label.textContent.trim() === 'Subscribe and Save' && 
//           !label.textContent.includes('Auto-renews')) {
//         label.textContent += ' ( Auto-renews, skip or cancel anytime )';
//       }
//     });
//   }

//   function hideOriginalPolicyText() {
//     const policyElement = document.querySelector('.shopify_subscriptions_app_policy');
//     if (policyElement) {
//       policyElement.style.display = 'none';
//     }
//   }

//   function reorderSubscriptionOptions() {
//     const planCard = document.querySelector('.plan_card');
//     if (!planCard) return false;

//     const groups = planCard.querySelectorAll('.subscription_group');
//     if (groups.length < 2) return false;

//     let otpGroup = null;
//     let subGroup = null;

//     groups.forEach(group => {
//       if (group.querySelector('input[data-radio-type="one_time_purchase"]')) {
//         otpGroup = group;
//       } else if (group.querySelector('input[data-radio-type="selling_plan"]')) {
//         subGroup = group;
//       }
//     });

//     if (subGroup && otpGroup && subGroup.previousElementSibling !== null) {
//       planCard.insertBefore(subGroup, otpGroup);
//       return true;
//     }
//     return false;
//   }

//   function runAll() {
//     reorderSubscriptionOptions();
//     selectSubscribeByDefault();
//     appendSubscriptionText();
//     hideOriginalPolicyText();
//   }

//   // Initial attempts
//   setTimeout(runAll, 500);
//   setTimeout(runAll, 1500);

//   // MutationObserver as a safety net in case widget loads late or re-renders
//   const observer = new MutationObserver(() => {
//     const planCard = document.querySelector('.plan_card');
//     if (planCard) {
//       runAll();
//     }
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });

//   // Stop observing after 10 seconds to avoid unnecessary work
//   setTimeout(() => observer.disconnect(), 10000);
// })();
